unit Main;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset, TerminalForm,
  XData.Web.Dataset, XData.Web.Connection, WEBLib.DB, Vcl.Controls, System.DateUtils,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls, WEBLib.EditAutocomplete,
  WEBLib.Grids, WEBLib.ExtCtrls, WEBLib.JQCtrls, WEBLib.JQGrid, Vcl.Forms,
  Vcl.Imaging.pngimage, XData.Web.Client, Client.Constants, WEBLib.SideMenu;

type
  TfrmMain = class(TForm)
    panHeader: TPanel;
    panFooter: TPanel;
    lblTitle: TLabel;
    panMain: TPanel;
    imgLogo: TImageControl;
    lblVoznik: TLabel;
    lblVozilo: TLabel;
    lblFrakcija: TLabel;
    lblDan: TLabel;
    btnFrakcija: TButton;
    panMenu: TPanel;
    btnLogout: TButton;
    btnMode: TButton;
    btnMenu: TButton;
    btnZc: TButton;
    btnSjs: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure btnLogoutClick(Sender: TObject);
    procedure imgLogoDblClick(Sender: TObject);
    procedure lblTitleClick(Sender: TObject);
    procedure lblFrakcijaClick(Sender: TObject);
    procedure lblVoziloDblClick(Sender: TObject);
    procedure btnFrakcijaClick(Sender: TObject);
    procedure btnMenuClick(Sender: TObject);
    procedure btnSjsClick(Sender: TObject);
    procedure btnZcClick(Sender: TObject);
  private
    { Private declarations }
    FLahkoZamenjaFrakcijo: boolean;
    FLahkoZamenjaVozilo: boolean;
    procedure ClearForm;
  public
    { Public declarations }
    frm: TTerminalForm;
    FormPrevious: string;
    FormCurrent: string;

    procedure ApplyTheme;

    procedure ShowPrevious;

    procedure ShowLogin;
    procedure ShowLokacije;
    procedure ShowZemljevid;
    procedure ShowOdvoz;
    procedure ShowOdvozInfo;
    procedure ShowFrakcija;
    procedure ShowFrakcijaEx(Previous: string);
    procedure ShowVozila;
    procedure ShowMenjava;
    procedure ShowKoledar(Nacin: TKoledarNacin; Naslov: string);
    procedure ShowSettings;
    procedure ShowZgodovina;
    procedure ShowZgodovinaLokacije(LokacijaId: integer; LokacijaNaziv: string);
    procedure ShowKilometri(Namen: TNamen);
    procedure ShowGorivo;
    procedure ShowPotrditev(Naslov, Tekst: string);
    procedure ShowLokacijeIzbor;

    procedure ShowNalogi;
    procedure ShowNalogiPranje;
    procedure ShowZemljevidCnt(NalogId: integer; Lat, Lon: double);
    procedure ShowNalog;
    procedure ShowPranje;
    procedure ShowKontejner(NalogId: integer);
    procedure ShowTeza(NalogPodrobnoId: integer);
    procedure ShowStortive;

    procedure ToggleLogoutBtn(Enabled: boolean);
    procedure SetVoznikLabel(Txt: string);
    procedure SetVoziloLabel(Txt: string);
    procedure SetFrakcijaLabel(Txt: string);
    procedure SetDanLabel(DanIme: string; Datum: TDate);

    procedure ProcessLokacija;

    procedure PrikaziObvestilo(Naslov, Sporocilo: string);
    procedure PrikaziPredloge(LokacijaId: integer);
    procedure PrikaziOpombe(Namen: integer);
  protected procedure LoadDFMValues; override; end;

var
  frmMain: TfrmMain;

implementation

{$R *.dfm}

uses Login, Client.Core, Client.Settings, Lokacija, Odvoz, Frakcija, Vozilo, VoziloMenjava,
     Settings, Zemljevid, Auth.Service, OdvozInfo, Zgodovina, Datum, Kilometri, Gorivo, Potrditev, KontejnerPredaja, Nalog, Nalogi, Storitve, Teza, Obvestilo,
  ZgodovinaLokacija, Client.Constants.Geo, NalogiPranje, Pranje, Predlog,
  LokacijaIzbor, Opombe;

procedure TfrmMain.ApplyTheme;
begin
  modMain.Log('ApplyTheme main');
  if modMain.AppSettings.DarkMode then begin
    self.SetColorScheme(csDark);
    panMain.Color := $00191919;
    panMain.Font.Color := clWhite;
    panHeader.Color := $002C2C2C;
  end else begin
    self.SetColorScheme(csLight);
    panMain.Color := clWhite;
    panMain.Font.Color := clBlack;
    panHeader.Color := clBlack;
  end;
  panFooter.Color := panHeader.Color;
  panMenu.Color := panHeader.Color;

  if Assigned(frm) then
    frm.ApplyTheme;
end;

procedure TfrmMain.btnLogoutClick(Sender: TObject);
begin
  ShowKilometri(kmOdjava);

  if modMain.VrniTipvozila = tvPralec then
    modMain.ZakljuciPralneNaloge(DateOf(Yesterday), Now);
  panMenu.Hide;
end;

procedure TfrmMain.btnMenuClick(Sender: TObject);

  function SetHeight(Control: TButton; LastHeight: integer): integer;
  begin
    Result := LastHeight;
    if Control.Visible then
      Result := Control.Top + Control.Height;
  end;

var
  panH: integer;
begin
  panMenu.Left := btnMenu.Left - 10;

  panH := SetHeight(btnLogout, panH);
  panH := SetHeight(btnMode, panH);
  panH := SetHeight(btnSjs, panH);
  panH := SetHeight(btnZc, panH);

  panMenu.Height := panH + 6;

  panMenu.Visible := not panMenu.Visible;
end;

procedure TfrmMain.btnZcClick(Sender: TObject);
begin
  modMain.OdpriPrehod(2);
  panMenu.Hide;
end;

procedure TfrmMain.btnSjsClick(Sender: TObject);
begin
  modMain.OdpriPrehod(portSjs);
  panMenu.Hide;
end;

procedure TfrmMain.btnFrakcijaClick(Sender: TObject);
begin
  if frm is TfrmLokacija then begin
    // Izbira frakcije
    ShowFrakcija;
  end;
end;

procedure TfrmMain.ClearForm;
begin
  if Assigned(frm) and not frm.IsDialog then begin
    FormPrevious := frm.ClassName;

    modMain.Log('FormPrevious='+FormPrevious);
    frm.Close;
    frm := nil;
  end;
  btnFrakcija.Visible := false;
end;

procedure TfrmMain.imgLogoDblClick(Sender: TObject);
begin
  if frm is TfrmLokacija then
    ShowSettings;
end;

procedure TfrmMain.PrikaziObvestilo(Naslov, Sporocilo: string);

  procedure AfterCreate(AForm: TObject);
  begin
    (AForm as TfrmObvestilo).Naslov := Naslov;
    (AForm as TfrmObvestilo).Tekst := Sporocilo;

    (AForm as TfrmObvestilo).Center;
  end;

begin
  frmObvestilo := TfrmObvestilo.CreateNew(@AfterCreate);
  frmObvestilo.Popup := true;
  frmObvestilo.PopupOpacity := 0.2; // only needed when main form should remain visible under a layer with opacity
  frmObvestilo.ShowModal(nil);
end;

procedure TfrmMain.PrikaziOpombe(Namen: integer);

(*  procedure AfterCreate(AForm: TObject);
  begin
    (AForm as TfrmOpombe).Namen := Namen;
    (AForm as TfrmOpombe).Center;
  end; *)

begin
(*  frmOpombe := TfrmOpombe.CreateNew(@AfterCreate);
  frmOpombe.Popup := true;
  frmOpombe.PopupOpacity := 0.2; // only needed when main form should remain visible under a layer with opacity
  frmOpombe.ShowModal(nil); *)
end;

procedure TfrmMain.PrikaziPredloge(LokacijaId: integer);

(*  procedure AfterCreate(AForm: TObject);
  begin
    console.Log('(PrikaziPredloge) LokacijaId='+LokacijaId.ToString);
    (AForm as TfrmPredlog).LokacijaId := LokacijaId;
//    (AForm as TfrmPredlog).Center;
  end; *)

begin
  frmPredlog := TfrmPredlog.CreateNew('');
  frmPredlog.Popup := True;
  frmPredlog.PopupOpacity := 0.2;
  frmPredlog.Border := fbNone;
  frmPredlog.ShowModal;
end;

procedure TfrmMain.ProcessLokacija;
var
  deltaSjs: double;
  deltaZc: double;
begin
  try
    if frm is TfrmLokacija then begin
      TfrmLokacija(frm).ProcesirajLokacijo;
    end;

    {$REGION 'Prikaz gumbov za portone'}
    deltaSjs := modMain.RazdaljaM(modMain.LokacijaLat, modMain.LokacijaLon, geoSJS.Lat, geoSJS.Lon);
    btnSjs.Visible := btnLogout.Visible and (deltaSjs < 1000); // Prikaži samo, ko si 1km od portona
    modMain.Log('Porton Sjs razdalja: '+FloatToStr(deltaSjs));

    deltaZc := modMain.RazdaljaM(modMain.LokacijaLat, modMain.LokacijaLon, geoZC.Lat, geoZC.Lon);
    btnZc.Visible := btnLogout.Visible and (deltaZc < 1000); // Prikaži samo, ko si 1 km od portona
    modMain.Log('Porton ZC razdalja: '+FloatToStr(deltaZc));
    {$ENDREGION}
  except
    on E:Exception do begin
      modMain.Log('(ProcessLokacija) '+E.Message);
    end;
  end;
end;

procedure TfrmMain.SetVoznikLabel(Txt: string);
begin
  lblVoznik.Caption := Txt;
end;

procedure TfrmMain.SetVoziloLabel(Txt: string);
begin
  lblVozilo.Caption := Txt;
end;

procedure TfrmMain.SetDanLabel(DanIme: string; Datum: TDate);
begin
  lblDan.Caption := DanIme+', '+FormatDateTime('dd.mm.yyyy', Datum);
end;

procedure TfrmMain.SetFrakcijaLabel(Txt: string);
begin
  lblFrakcija.Caption := Txt+' ';
end;

procedure TfrmMain.ShowLogin;
begin
  ClearForm;
  modMain.UstaviSledenje;
  ToggleLogoutBtn(false);
  frm :=  TfrmLogin.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowMenjava;
begin
  ClearForm;
  frm :=  TfrmMenjava.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowLokacije;
begin
  ClearForm;
//  btnFrakcija.Visible := true;
  ToggleLogoutBtn(true);
  frm :=  TfrmLokacija.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ToggleLogoutBtn(Enabled: boolean);
begin
  btnLogout.Visible := Enabled;
  btnSjs.Visible := Enabled;
  btnZc.Visible := false; //Enabled;  // Vklopi ko deluje webhook
end;

procedure TfrmMain.ShowOdvoz;
begin
  ClearForm;
  frm :=  TfrmOdvoz.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowOdvozInfo;
begin
  ClearForm;
  frm :=  TfrmOdvozInfo.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowPrevious;
begin
  if FormPrevious=TfrmFrakcija.ClassName then begin
    ShowFrakcija;
  end else if FormPrevious=TfrmLokacija.ClassName then begin
    ShowLokacije;
  end else if FormPrevious=TfrmVozilo.ClassName then begin
    ShowVozila
  end else if FormPrevious=TfrmMenjava.ClassName then begin
    ShowMenjava;
  end else if FormPrevious=TfrmSettings.ClassName then begin
    ShowSettings;
  end else if FormPrevious=TfrmOdvoz.ClassName then begin
    ShowOdvoz;
  end else if FormPrevious=TfrmOdvozInfo.ClassName then begin
    ShowOdvozInfo;
  end else if FormPrevious=TfrmZemljevid.ClassName then begin
    ShowZemljevid;
  end else if FormPrevious=TfrmZgodovina.ClassName then begin
    ShowZgodovina;
  end else if FormPrevious=TfrmNalogi.ClassName then begin
    ShowNalogi;
  end else if FormPrevious=TfrmNalog.ClassName then begin
    ShowNalog;
  end else if FormPrevious=TfrmNalogiPranje.ClassName then begin
    ShowNalogiPranje;
  end else if FormPrevious=TfrmPranje.ClassName then begin
    ShowPranje;
  end else if FormPrevious=TfrmVozilo.ClassName then begin
    ShowVozila
  end else if FormPrevious=TfrmDatum.ClassName then begin
    ShowKoledar(knPrivzeto, 'Izberi dan za delo');
  end else if FormPrevious=TfrmZemljevid.ClassName then begin
    ShowZemljevidCnt(0,0,0);
  end else begin
    ShowLogin;
  end;
end;

procedure TfrmMain.ShowSettings;
begin
  ClearForm;
  frm :=  TfrmSettings.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowFrakcija;
begin
  ClearForm;
  frm :=  TfrmFrakcija.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowFrakcijaEx(Previous: string);
begin
  ClearForm;
  FormPrevious := Previous;
  modMain.Log('FormPrevious='+FormPrevious);
  frm :=  TfrmFrakcija.CreateNew(panMain.ElementID, nil);
  TfrmFrakcija(frm).CustomPrevious := Previous;
end;

procedure TfrmMain.ShowKoledar(Nacin: TKoledarNacin; Naslov: string);

  procedure AfterCreate(AForm: TObject);
  begin
    (frm as TfrmDatum).Naslov := Naslov;
  end;

begin
  ClearForm;
  frm := TfrmDatum.CreateNew(panMain.ElementID, @AfterCreate);
  TfrmDatum(frm).Nacin := Nacin;
end;

procedure TfrmMain.ShowVozila;
begin
  ClearForm;
  frm :=  TfrmVozilo.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowZemljevid;
begin
  ClearForm;
  frm :=  TfrmZemljevid.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowZgodovina;
begin
  ClearForm;
  modMain.Log('Odpiranje zgodovine');
  frm :=  TfrmZgodovina.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowLokacijeIzbor;
begin
  ClearForm;
  frm :=  TfrmLokacijaIzbor.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowZgodovinaLokacije(LokacijaId: integer; LokacijaNaziv: string);

  procedure AfterCreate(AForm: TObject);
  begin
    (frm as TfrmZgodovinaLokacija).LokacijaId := LokacijaId;
    (frm as TfrmZgodovinaLokacija).lblTitle.Caption := 'Odvozi za '+LokacijaNaziv;
    (frm as TfrmZgodovinaLokacija).tmrFindTimer(nil);
  end;

begin
  ClearForm;
  modMain.Log('Odpiranje zgodovine lokacije');
  frm :=  TfrmZgodovinaLokacija.CreateNew(panMain.ElementID, @AfterCreate);
end;

procedure TfrmMain.ShowKilometri(Namen: TNamen);
  procedure AfterCreate(AForm: TObject);
  begin
    (frm as TfrmKilometri).Namen := Namen;
  end;
begin
  ClearForm;
  if Namen = kmGorivo then
    ToggleLogoutBtn(true)
  else
    ToggleLogoutBtn(false);

  frm := TfrmKilometri.CreateNew(panMain.ElementID, @AfterCreate);
end;

procedure TfrmMain.ShowGorivo;
  procedure AfterCreate(AForm: TObject);
  begin
  end;
begin
  ClearForm;
  ToggleLogoutBtn(true);
  frm :=  TfrmGorivo.CreateNew(panMain.ElementID, @AfterCreate);
end;

procedure TfrmMain.ShowPotrditev(Naslov, Tekst: string);
  procedure AfterCreate(AForm: TObject);
  begin
    TfrmPotrditev(AForm).Naslov := Naslov;
    TfrmPotrditev(AForm).Tekst := Tekst;
  end;

begin
  ClearForm;
  ToggleLogoutBtn(false);
  frm := TfrmPotrditev.CreateNew(panMain.ElementID, @AfterCreate);
end;

procedure TfrmMain.WebFormCreate(Sender: TObject);

(*  procedure LoginSuccess;
  begin
    //FLoginProc;
  end;

  procedure LoginError(AMsg: string);
  begin
    //ShowNotification('Login Error: ' + AMsg);
  end; *)

begin
  Application.ErrorType := aeSilent;
  modMain.NastaviDatumZgodovina(Now); // Začetni datum
  modMain.VoziloId := StrToIntDef(modMain.GetVar('VoziloId'), 0);   // Zadnje uporabljano vozilo
  Console.Log('modMain.VoziloId='+modMain.VoziloId.ToString);

  imgLogo.LoadFromURL('graphics/logo.png');
  ApplyTheme;

  Frm := nil;
  ShowLogin;
end;

procedure TfrmMain.lblFrakcijaClick(Sender: TObject);
begin
  if frm is TfrmLokacija then begin
    // Izbira frakcije
    ShowFrakcija;
  end;
end;

procedure TfrmMain.lblTitleClick(Sender: TObject);
begin
//  PrikazBaterije;
  modMain.AppSettings.DarkMode := not modMain.AppSettings.DarkMode;

  if modMain.AppSettings.DarkMode then
    btnMode.Caption := '<i class="material-icons">light_mode</i>'
  else
    btnMode.Caption := '<i class="material-icons">dark_mode</i>';
  ApplyTheme;
  panMenu.Hide;
end;

procedure TfrmMain.lblVoziloDblClick(Sender: TObject);
begin
//  if frm is TfrmLokacija then begin
//    ShowVozila;
//  end;
end;

procedure TfrmMain.ShowNalogi;
begin
  modMain.Log('ShowNalogi');
  ClearForm;
  ToggleLogoutBtn(true);
  frm := TfrmNalogi.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowNalogiPranje;
begin
  modMain.Log('ShowNalogiPranje');
  ClearForm;
  ToggleLogoutBtn(true);
  frm := TfrmNalogiPranje.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowPranje;
begin
  ClearForm;
  ToggleLogoutBtn(true);
  frm := TfrmPranje.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowNalog;
begin
  ClearForm;
  ToggleLogoutBtn(true);
  frm := TfrmNalog.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowZemljevidCnt(NalogId: integer; Lat, Lon: double);
begin
  modMain.SetCoordinate(Lon, Lat);

  ClearForm;
  frm :=  TfrmZemljevid.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowKontejner(NalogId: integer);
begin
  ClearForm;
  frm := TfrmPredajaKontejner.CreateNew(panMain.ElementID, nil);
  TfrmPredajaKontejner(frm).NalogId := NalogId;
end;

procedure TfrmMain.ShowTeza(NalogPodrobnoId: integer);
begin
  ClearForm;
  frm := TfrmTeza.CreateNew(panMain.ElementID, nil);
  TfrmTeza(frm).NalogPodrobnoId := NalogPodrobnoId;
end;

procedure TfrmMain.ShowStortive;
begin
  ClearForm;
  frm := TfrmStoritve.CreateNew(panMain.ElementID, nil);
//  TfrmStoritve(frm).NalogPodrobnoId := NalogPodrobnoId;
end;

procedure TfrmMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  panHeader := TPanel.Create(Self);
  lblTitle := TLabel.Create(Self);
  imgLogo := TImageControl.Create('imgLogo');
  lblDan := TLabel.Create(Self);
  btnMenu := TButton.Create(Self);
  panFooter := TPanel.Create(Self);
  lblVoznik := TLabel.Create(Self);
  lblVozilo := TLabel.Create(Self);
  lblFrakcija := TLabel.Create(Self);
  btnFrakcija := TButton.Create(Self);
  panMain := TPanel.Create(Self);
  panMenu := TPanel.Create(Self);
  btnLogout := TButton.Create(Self);
  btnMode := TButton.Create(Self);
  btnZc := TButton.Create(Self);
  btnSjs := TButton.Create(Self);

  panHeader.BeforeLoadDFMValues;
  lblTitle.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblDan.BeforeLoadDFMValues;
  btnMenu.BeforeLoadDFMValues;
  panFooter.BeforeLoadDFMValues;
  lblVoznik.BeforeLoadDFMValues;
  lblVozilo.BeforeLoadDFMValues;
  lblFrakcija.BeforeLoadDFMValues;
  btnFrakcija.BeforeLoadDFMValues;
  panMain.BeforeLoadDFMValues;
  panMenu.BeforeLoadDFMValues;
  btnLogout.BeforeLoadDFMValues;
  btnMode.BeforeLoadDFMValues;
  btnZc.BeforeLoadDFMValues;
  btnSjs.BeforeLoadDFMValues;
  try
    Name := 'frmMain';
    Width := 668;
    Height := 761;
    Align := alClient;
    Caption := 'Kamijon'#269'in';
    CSSLibrary := cssBootstrap;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    panHeader.SetParentComponent(Self);
    panHeader.Name := 'panHeader';
    panHeader.Left := 0;
    panHeader.Top := 0;
    panHeader.Width := 668;
    panHeader.Height := 70;
    panHeader.Align := alTop;
    panHeader.BorderStyle := bsNone;
    panHeader.ChildOrder := 3;
    panHeader.Color := clBlack;
    panHeader.Padding.Left := 3;
    panHeader.Padding.Top := 3;
    panHeader.Padding.Right := 3;
    panHeader.Padding.Bottom := 3;
    panHeader.TabOrder := 0;
    lblTitle.SetParentComponent(panHeader);
    lblTitle.Name := 'lblTitle';
    lblTitle.AlignWithMargins := True;
    lblTitle.Left := 68;
    lblTitle.Top := 6;
    lblTitle.Width := 132;
    lblTitle.Height := 58;
    lblTitle.Margins.Left := 10;
    lblTitle.Align := alLeft;
    lblTitle.Anchors := [akLeft,akTop,akRight,akBottom];
    lblTitle.Caption := 'Kamijon'#269'in';
    lblTitle.ElementClassName := 'h2 text-light';
    lblTitle.ElementFont := efCSS;
    lblTitle.Font.Charset := DEFAULT_CHARSET;
    lblTitle.Font.Color := clWhite;
    lblTitle.Font.Height := -27;
    lblTitle.Font.Name := 'Arial';
    lblTitle.Font.Style := [];
    lblTitle.HeightPercent := 100.000000000000000000;
    lblTitle.Layout := tlCenter;
    lblTitle.ParentFont := False;
    lblTitle.WidthPercent := 100.000000000000000000;
    imgLogo.SetParentComponent(panHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.AlignWithMargins := True;
    imgLogo.Left := 6;
    imgLogo.Top := 6;
    imgLogo.Width := 49;
    imgLogo.Height := 58;
    imgLogo.ElementClassName := 'transparent';
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Align := alLeft;
    imgLogo.ChildOrder := 5;
    SetEvent(imgLogo, Self, 'OnDblClick', 'imgLogoDblClick');
    imgLogo.Picture.LoadFromFile('Main.panHeader.imgLogo.Picture.png');
    lblDan.SetParentComponent(panHeader);
    lblDan.Name := 'lblDan';
    lblDan.AlignWithMargins := True;
    lblDan.Left := 213;
    lblDan.Top := 6;
    lblDan.Width := 382;
    lblDan.Height := 58;
    lblDan.Margins.Left := 10;
    lblDan.Align := alClient;
    lblDan.Alignment := taRightJustify;
    lblDan.AutoSize := False;
    lblDan.ElementClassName := 'h3 text-light';
    lblDan.ElementFont := efCSS;
    lblDan.Font.Charset := DEFAULT_CHARSET;
    lblDan.Font.Color := clWhite;
    lblDan.Font.Height := -21;
    lblDan.Font.Name := 'Tahoma';
    lblDan.Font.Style := [];
    lblDan.HeightPercent := 100.000000000000000000;
    lblDan.Layout := tlCenter;
    lblDan.ParentFont := False;
    lblDan.WidthPercent := 100.000000000000000000;
    btnMenu.SetParentComponent(panHeader);
    btnMenu.Name := 'btnMenu';
    btnMenu.AlignWithMargins := True;
    btnMenu.Left := 601;
    btnMenu.Top := 3;
    btnMenu.Width := 61;
    btnMenu.Height := 64;
    btnMenu.Margins.Top := 0;
    btnMenu.Margins.Bottom := 0;
    btnMenu.Align := alRight;
    btnMenu.Caption := '<i class="material-icons">menu</i>';
    btnMenu.ChildOrder := 2;
    btnMenu.ElementClassName := 'btn btn-dark';
    btnMenu.ElementFont := efCSS;
    btnMenu.HeightPercent := 100.000000000000000000;
    btnMenu.WidthPercent := 100.000000000000000000;
    SetEvent(btnMenu, Self, 'OnClick', 'btnMenuClick');
    panFooter.SetParentComponent(Self);
    panFooter.Name := 'panFooter';
    panFooter.Left := 0;
    panFooter.Top := 716;
    panFooter.Width := 668;
    panFooter.Height := 45;
    panFooter.Align := alBottom;
    panFooter.BorderColor := clBlack;
    panFooter.BorderStyle := bsNone;
    panFooter.ChildOrder := 3;
    panFooter.Color := clBlack;
    panFooter.ElementFont := efCSS;
    panFooter.Padding.Left := 1;
    panFooter.Padding.Top := 1;
    panFooter.Padding.Right := 1;
    panFooter.Padding.Bottom := 1;
    panFooter.ShowCaption := False;
    panFooter.TabOrder := 1;
    lblVoznik.SetParentComponent(panFooter);
    lblVoznik.Name := 'lblVoznik';
    lblVoznik.AlignWithMargins := True;
    lblVoznik.Left := 129;
    lblVoznik.Top := 4;
    lblVoznik.Width := 300;
    lblVoznik.Height := 37;
    lblVoznik.Margins.Left := 10;
    lblVoznik.Margins.Right := 10;
    lblVoznik.Align := alClient;
    lblVoznik.Alignment := taCenter;
    lblVoznik.Caption := 'NEZNANI VOZNIK';
    lblVoznik.ElementClassName := 'h3 text-light';
    lblVoznik.ElementFont := efCSS;
    lblVoznik.Font.Charset := DEFAULT_CHARSET;
    lblVoznik.Font.Color := clWhite;
    lblVoznik.Font.Height := -21;
    lblVoznik.Font.Name := 'Tahoma';
    lblVoznik.Font.Style := [];
    lblVoznik.HeightPercent := 100.000000000000000000;
    lblVoznik.Layout := tlCenter;
    lblVoznik.ParentFont := False;
    lblVoznik.WidthPercent := 100.000000000000000000;
    lblVozilo.SetParentComponent(panFooter);
    lblVozilo.Name := 'lblVozilo';
    lblVozilo.AlignWithMargins := True;
    lblVozilo.Left := 11;
    lblVozilo.Top := 4;
    lblVozilo.Width := 98;
    lblVozilo.Height := 37;
    lblVozilo.Margins.Left := 10;
    lblVozilo.Margins.Right := 10;
    lblVozilo.Align := alLeft;
    lblVozilo.Caption := 'KP AA-000';
    lblVozilo.ElementClassName := 'h3 text-light';
    lblVozilo.ElementFont := efCSS;
    lblVozilo.Font.Charset := DEFAULT_CHARSET;
    lblVozilo.Font.Color := clWhite;
    lblVozilo.Font.Height := -21;
    lblVozilo.Font.Name := 'Tahoma';
    lblVozilo.Font.Style := [];
    lblVozilo.HeightPercent := 100.000000000000000000;
    lblVozilo.Layout := tlCenter;
    lblVozilo.ParentFont := False;
    lblVozilo.WidthPercent := 100.000000000000000000;
    SetEvent(lblVozilo, Self, 'OnDblClick', 'lblVoziloDblClick');
    lblFrakcija.SetParentComponent(panFooter);
    lblFrakcija.Name := 'lblFrakcija';
    lblFrakcija.AlignWithMargins := True;
    lblFrakcija.Left := 442;
    lblFrakcija.Top := 4;
    lblFrakcija.Width := 173;
    lblFrakcija.Height := 37;
    lblFrakcija.Margins.Right := 10;
    lblFrakcija.Align := alRight;
    lblFrakcija.Alignment := taRightJustify;
    lblFrakcija.Caption := 'PAPIR IN KARTON';
    lblFrakcija.ElementClassName := 'h3 text-light';
    lblFrakcija.ElementFont := efCSS;
    lblFrakcija.Font.Charset := DEFAULT_CHARSET;
    lblFrakcija.Font.Color := clWhite;
    lblFrakcija.Font.Height := -21;
    lblFrakcija.Font.Name := 'Tahoma';
    lblFrakcija.Font.Style := [];
    lblFrakcija.HeightPercent := 100.000000000000000000;
    lblFrakcija.Layout := tlCenter;
    lblFrakcija.ParentFont := False;
    lblFrakcija.WidthPercent := 100.000000000000000000;
    SetEvent(lblFrakcija, Self, 'OnDblClick', 'lblFrakcijaClick');
    btnFrakcija.SetParentComponent(panFooter);
    btnFrakcija.Name := 'btnFrakcija';
    btnFrakcija.AlignWithMargins := True;
    btnFrakcija.Left := 628;
    btnFrakcija.Top := 6;
    btnFrakcija.Width := 33;
    btnFrakcija.Height := 35;
    btnFrakcija.Margins.Top := 5;
    btnFrakcija.Margins.Right := 6;
    btnFrakcija.Align := alRight;
    btnFrakcija.Caption := '<i class="material-icons" style="font-size:20px;">recycling</i>';
    btnFrakcija.ChildOrder := 1;
    btnFrakcija.ElementClassName := 'btn btn-dark';
    btnFrakcija.ElementFont := efCSS;
    btnFrakcija.HeightStyle := ssAuto;
    btnFrakcija.HeightPercent := 100.000000000000000000;
    btnFrakcija.WidthPercent := 100.000000000000000000;
    SetEvent(btnFrakcija, Self, 'OnClick', 'btnFrakcijaClick');
    panMain.SetParentComponent(Self);
    panMain.Name := 'panMain';
    panMain.Left := 0;
    panMain.Top := 70;
    panMain.Width := 668;
    panMain.Height := 646;
    panMain.Align := alClient;
    panMain.BorderColor := clWhite;
    panMain.BorderStyle := bsNone;
    panMain.ChildOrder := 2;
    panMain.Color := clWhite;
    panMain.ElementFont := efCSS;
    panMain.ShowCaption := False;
    panMain.TabOrder := 2;
    panMenu.SetParentComponent(Self);
    panMenu.Name := 'panMenu';
    panMenu.Left := 592;
    panMenu.Top := 70;
    panMenu.Width := 76;
    panMenu.Height := 275;
    panMenu.BorderColor := clWhite;
    panMenu.BorderStyle := bsNone;
    panMenu.ChildOrder := 2;
    panMenu.Color := clBlack;
    panMenu.ElementFont := efCSS;
    panMenu.ShowCaption := False;
    panMenu.TabOrder := 3;
    panMenu.Visible := False;
    btnLogout.SetParentComponent(panMenu);
    btnLogout.Name := 'btnLogout';
    btnLogout.AlignWithMargins := True;
    btnLogout.Left := 6;
    btnLogout.Top := 3;
    btnLogout.Width := 64;
    btnLogout.Height := 63;
    btnLogout.Margins.Left := 6;
    btnLogout.Margins.Right := 6;
    btnLogout.Align := alTop;
    btnLogout.Caption := '<i class="material-icons">logout</i>';
    btnLogout.ElementClassName := 'btn btn-danger';
    btnLogout.ElementFont := efCSS;
    btnLogout.HeightPercent := 100.000000000000000000;
    btnLogout.Visible := False;
    btnLogout.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogout, Self, 'OnClick', 'btnLogoutClick');
    btnMode.SetParentComponent(panMenu);
    btnMode.Name := 'btnMode';
    btnMode.AlignWithMargins := True;
    btnMode.Left := 6;
    btnMode.Top := 72;
    btnMode.Width := 64;
    btnMode.Height := 61;
    btnMode.Margins.Left := 6;
    btnMode.Margins.Right := 6;
    btnMode.Align := alTop;
    btnMode.Caption := '<i class="material-icons">dark_mode</i>';
    btnMode.ChildOrder := 2;
    btnMode.ElementClassName := 'btn btn-dark';
    btnMode.ElementFont := efCSS;
    btnMode.HeightPercent := 100.000000000000000000;
    btnMode.WidthPercent := 100.000000000000000000;
    SetEvent(btnMode, Self, 'OnClick', 'lblTitleClick');
    btnZc.SetParentComponent(panMenu);
    btnZc.Name := 'btnZc';
    btnZc.AlignWithMargins := True;
    btnZc.Left := 6;
    btnZc.Top := 206;
    btnZc.Width := 64;
    btnZc.Height := 61;
    btnZc.Margins.Left := 6;
    btnZc.Margins.Right := 6;
    btnZc.Align := alTop;
    btnZc.Caption := 'Porton<br>ZC';
    btnZc.ChildOrder := 2;
    btnZc.ElementClassName := 'btn btn-primary';
    btnZc.ElementFont := efCSS;
    btnZc.HeightPercent := 100.000000000000000000;
    btnZc.WidthPercent := 100.000000000000000000;
    SetEvent(btnZc, Self, 'OnClick', 'btnZcClick');
    btnSjs.SetParentComponent(panMenu);
    btnSjs.Name := 'btnSjs';
    btnSjs.AlignWithMargins := True;
    btnSjs.Left := 6;
    btnSjs.Top := 139;
    btnSjs.Width := 64;
    btnSjs.Height := 61;
    btnSjs.Margins.Left := 6;
    btnSjs.Margins.Right := 6;
    btnSjs.Align := alTop;
    btnSjs.Caption := 'Porton<br>SJS';
    btnSjs.ChildOrder := 2;
    btnSjs.ElementClassName := 'btn btn-primary';
    btnSjs.ElementFont := efCSS;
    btnSjs.HeightPercent := 100.000000000000000000;
    btnSjs.WidthPercent := 100.000000000000000000;
    SetEvent(btnSjs, Self, 'OnClick', 'btnSjsClick');
  finally
    panHeader.AfterLoadDFMValues;
    lblTitle.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblDan.AfterLoadDFMValues;
    btnMenu.AfterLoadDFMValues;
    panFooter.AfterLoadDFMValues;
    lblVoznik.AfterLoadDFMValues;
    lblVozilo.AfterLoadDFMValues;
    lblFrakcija.AfterLoadDFMValues;
    btnFrakcija.AfterLoadDFMValues;
    panMain.AfterLoadDFMValues;
    panMenu.AfterLoadDFMValues;
    btnLogout.AfterLoadDFMValues;
    btnMode.AfterLoadDFMValues;
    btnZc.AfterLoadDFMValues;
    btnSjs.AfterLoadDFMValues;
  end;
end;

end.
      